module.exports = "<div class=\"app-wrap\"><iframe class=\"iframestyle\" frameBorder=\"0\" [src]=\"urlSafe\"></iframe></div>"